import FormControl from '@zenbusiness/zui/FormControl';
import InputLabel from '@zenbusiness/zui/InputLabel';
import Select from '@zenbusiness/zui/Select';
import { lightTheme, styled } from '@zenbusiness/zui/styles';

export const FormControlStyle = ({ theme, bordered }) => ({
  '& .MuiInputBase-root.Mui-focused': {
    borderRadius: '12px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.fixed.black,
      borderWidth: bordered ? '1px' : '0px'
    }
  },
  '& .MuiInputBase-root .MuiSvgIcon-fontSizeMedium': {
    fontSize: '18px',
    color: theme.palette.text.primary
  },
  '& .MuiInputBase-input': {
    paddingTop: '8px',
    paddingBottom: '8px'
  }
});

export const InputLabelStyle = ({ theme }) => ({
  '&.MuiInputLabel-root': {
    color: theme.palette.text.primary,
    paddingTop: '2px',
    '&.Mui-disabled': {
      opacity: '0.5'
    }
  }
});

export const SelectStyle = ({ bordered }) => ({
  height: '40px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: bordered ? '1px' : '0px'
  },
  '&.Mui-disabled': {
    opacity: '0.5'
  }
});

export const MenuStyle = {
  '& .MuiMenu-paper': {
    borderRadius: '16px',
    boxShadow: '0px 4px 16px 2px rgba(0, 0, 0, 0.12)',
    padding: '16px 0 8px 0',
    maxHeight: '300px'
  }
};

export const MenuListStyle = {
  '& .MuiButtonBase-root': {
    padding: '8px 32px',
    backgroundColor: `${lightTheme.palette.background.grey.main}!important`,
    '&:hover': {
      backgroundColor: 'rgba(207, 249, 250, 0.4)!important'
    },
    marginBottom: '8px',
    '&.Mui-selected': {
      backgroundColor: `${lightTheme.palette.background.cyan.light}!important`
    }
  }
};

export const FormControlStyled = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== 'bordered'
})(FormControlStyle);

export const SelectStyled = styled(Select, {
  shouldForwardProp: (prop) => prop !== 'bordered'
})(SelectStyle);

export const InputLabelStyled = styled(InputLabel)(InputLabelStyle);
